import { createContext } from 'react';
import { EditorConfigContextType } from '../../types';

export const EditorConfigContext = createContext<
  Partial<EditorConfigContextType>
>({});
EditorConfigContext.displayName = 'EditorConfigContext';
